import { gql } from '@apollo/client';

import { groupFragment } from '../fragments';

export default gql`
  mutation DeleteGroup($courseId: String!, $groupId: String!) {
    group(courseId: $courseId, groupId: $groupId)
      @rest(
        type: "Group"
        path: "courses/{args.courseId}/groups/{args.groupId}"
        method: "DELETE"
      ) {
      ...Group
    }
  }
  ${groupFragment}
`;
